import { jsxs, jsx } from 'react/jsx-runtime';
import { Children } from 'react';
import { DateTime } from '@zapier/date';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { Avatar } from '../../display/Avatar/Avatar.es.js';
import 'clsx';
import { AvatarsWithText, AvatarText } from '../../display/Avatar/AvatarsWithText.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';
import { Img } from '../../display/Img/Img.es.js';
import { Link } from '../../navigation/Link/Link.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';

const root = "_root_n7psm_12";
const image = "_image_n7psm_36";
const imageInner = "_image-inner_n7psm_54";
const content = "_content_n7psm_63";
const title = "_title_n7psm_84";
const metaInfo = "_meta-info_n7psm_114";
const meta = "_meta_n7psm_114";
const metaItem = "_meta-item_n7psm_135";
const description = "_description_n7psm_145";
const category = "_category_n7psm_165";
const label = "_label_n7psm_177";
const styles = {
	root: root,
	image: image,
	imageInner: imageInner,
	content: content,
	title: title,
	metaInfo: metaInfo,
	meta: meta,
	metaItem: metaItem,
	description: description,
	category: category,
	label: label
};

const labelBackgroundColorConfig = {
  primary: "UiPrimaryWeakest",
  secondary: "BrandPeach",
  neutral: "GrayWarm3"
};
const ArticleTag = ({ label, labelIcon = "fileFilled", labelVariant = "neutral" }) => {
  return jsxs("span", { className: styles.label, style: {
    "--_zds-article-label-bgcolor": Colors[labelBackgroundColorConfig[labelVariant]]
  }, "data-zds": true, children: [labelIcon && jsx(Icon, { name: labelIcon, size: 18 }), jsx("span", { "data-zds": true, children: label })] });
};
const Article = (props) => {
  return jsxs("article", { className: styles.root, "data-layout": props.layout, "data-zds": true, children: [props.imageUrl && jsx("div", { className: styles.image, "data-layout": props.layout, "data-zds": true, children: jsx("div", { className: styles.imageInner, "data-zds": true, children: jsx(
    Img,
    {
      // `aria-hidden` and empty `alt` are applied since we do not describe
      // our images for screen readers. Understanding the content of the image
      // is not critical to understanding the content of the article.
      alt: "",
      "aria-hidden": true,
      aspectRatio: "2:1",
      borderRadius: "none",
      isBlock: true,
      loading: "lazy",
      objectFit: "cover",
      sizes: "100vw",
      src: props.imageUrl
    }
  ) }) }), jsxs("div", { className: styles.content, "data-layout": props.layout, "data-showimg": !!props.imageUrl, "data-rownoimg": props.layout === "row" && !props.imageUrl, "data-zds": true, children: [jsx(HeadingLevel, { children: jsx(Link, { className: styles.title, color: null, href: props.url, "data-lastelement": !props.author && !props.description, children: jsx(Heading, { children: props.title }) }) }), props.description && jsx("div", { className: styles.description, "data-layout": props.layout, "data-lastelement": !props.author, "data-zds": true, children: props.description }), props.author && jsx("div", { className: styles.metaInfo, children: jsxs(AvatarsWithText, { avatars: jsx(Avatar, { "aria-hidden": true, isBlock: true, name: props.author.name, size: "medium", url: props.author.imageUrl }), multiline: true, size: "medium", children: [jsx(AvatarText, { "aria-label": `by ${props.author.name}`, kind: "heavy", children: props.author.name }), props.meta] }) }), props.label && jsx(ArticleTag, { label: props.label, labelIcon: props.labelIcon, labelVariant: props.labelVariant }), props.category && props.categoryUrl && !props.label && jsx("div", { className: styles.category, "data-zds": true, children: jsx(Link, { "aria-label": `Categorized under ${props.category}`, href: props.categoryUrl, children: props.category }) })] })] });
};
const ArticleMeta = (props) => {
  const children = Children.toArray(props.children).filter(Boolean).map((child, i) => {
    return jsx("span", { className: styles.metaItem, "data-zds": true, children: child }, i);
  });
  return jsx(AvatarText, { kind: "light", children: jsx("span", { className: styles.meta, "data-zds": true, children }) });
};
const ArticleReadTime = (props) => {
  return jsxs("div", { "data-zds": true, children: [props.minutes, " min read"] });
};
const ArticleDate = (props) => {
  return jsx(DateTime, { date: props.date });
};

export { Article, ArticleDate, ArticleMeta, ArticleReadTime };
//# sourceMappingURL=Article.es.js.map
